import { FC, Fragment } from 'react';
import { useIntl } from 'react-intl';
import { useHistory } from 'react-router-dom';
import PruTable from 'src/app/common/components/PruTable/PruTable';
import { getDefaultDisplayDate } from 'src/app/common/utils';
import _ from 'lodash';
import { WalletCreditListRes } from 'src/app/modules/pruwallet/types/credit-type';

type WalletCreditListProps = {
  isLoading: boolean;
  listRes?: WalletCreditListRes;
  onRefresh: () => void;
  onChangePage: (page: number, rowsPerPage: number) => void;
};

const WalletCreditList: FC<WalletCreditListProps> = ({ isLoading, listRes, onRefresh, onChangePage }) => {
  const history = useHistory();
  const intl = useIntl();
  const Translation = (id: string) => intl.formatMessage({ id });

  return (
    <Fragment>
      <PruTable
        disableBulkSelect
        title={Translation('walletCredit.list')}
        operationDef={[]}
        columnDef={[
          {
            isId: true,
            keyIndex: 'agentCode',
            align: 'center',
            displayName: Translation('walletCredit.common.agentCode'),
            renderData: (row) => row?.agentCode || '',
          },
          {
            keyIndex: 'transactionDate',
            align: 'center',
            displayName: Translation('walletCredit.common.transactionDate'),
            renderData: (row) => (row.transactionDate ? getDefaultDisplayDate(row.transactionDate, 'date') : ''),
          },
          {
            keyIndex: 'expiryDate',
            align: 'center',
            displayName: Translation('walletCredit.common.expiryDate'),
            renderData: (row) => (row.expiryDate ? getDefaultDisplayDate(row.expiryDate, 'date') : ''),
          },
          {
            keyIndex: 'creditAdjusted',
            align: 'center',
            displayName: Translation('walletCredit.common.creditAdjusted'),
            renderData: (row) => String(row?.creditAmount || ''),
          },
          {
            keyIndex: 'adjustmentReasonEn',
            align: 'center',
            displayName: Translation('walletCredit.common.adjustmentReasonEn'),
            renderData: (row) => row?.adjustmentReasonEn || '',
          },
          {
            keyIndex: 'adjustmentReasonZh',
            align: 'center',
            displayName: Translation('walletCredit.common.adjustmentReasonZh'),
            renderData: (row) => row?.adjustmentReasonZh || '',
          },
        ]}
        isLoading={isLoading}
        onRefresh={onRefresh}
        dataSource={listRes?.data?.items}
        totalPages={listRes?.data?.totalPages}
        totalRecords={listRes?.data?.totalCount}
        onChangePage={onChangePage}
      />
    </Fragment>
  );
};

export default WalletCreditList;
